'use client'

import Button from '@eversports/klimt-primitives/alpha/Button'
import { useState } from 'react'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import { Sheet, SheetTrigger } from '../../../../../../../../../components/Sheet'
import { Calendar } from '../../../../../../../../../components/Calendar'
import FilterSheetContent from '../FilterSheetContent'
import { BRAND_SELECTED_CALENDAR_ICON, CALENDAR_ICON } from '../../../../../../../../App.icons'

interface Props {
  selectedDate?: Date
  formattedDate?: string
  updateFilter: (value: Date | undefined) => void
  resetFilter: () => void
}

const DateFilterSheet = ({ selectedDate, formattedDate, updateFilter, resetFilter }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const t = useTranslations('discover-sport-city')

  const dateIcon = formattedDate ? BRAND_SELECTED_CALENDAR_ICON : CALENDAR_ICON

  const toggleCalendar = () => setIsOpen(!isOpen)

  const handleSelect = (dateSelection: Date | undefined) => {
    updateFilter(dateSelection)
    toggleCalendar()
  }

  const handleReset = () => {
    resetFilter()
    toggleCalendar()
  }

  return (
    <Sheet open={isOpen} onOpenChange={toggleCalendar}>
      <SheetTrigger asChild className="order-2 flex flex-2 items-center gap-1 sm:hidden">
        <Button size="sm" variant={formattedDate ? 'tertiary-selected' : 'outline'} className="capitalize">
          <Image src={dateIcon} width={12} height={12} alt="" loading="lazy" />
          {formattedDate ?? t('start-date')}
        </Button>
      </SheetTrigger>
      <FilterSheetContent title={t('date-of-activity')} reset={handleReset}>
        <Calendar
          mode="single"
          selected={selectedDate}
          onSelect={handleSelect}
          weekStartsOn={1}
          defaultMonth={selectedDate ?? new Date()}
          fromDate={new Date()}
        />
      </FilterSheetContent>
    </Sheet>
  )
}

export default DateFilterSheet
